module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3lRzV"))).then(() => parcelRequire('1iHdE'));